export default __webpack_public_path__ + "2ca3a664b6ec82d4b29ccd03a8ed3b58.svg";